import { Table, TableHeader, TableRow, TableHeaderCell, TableBody, TableCell, Tooltip, Button, Toolbar, makeStyles, tokens } from "@fluentui/react-components";
import { AddFilled, AddRegular, bundleIcon, CheckmarkCircleRegular } from "@fluentui/react-icons";
import LinkWithIcon from "../../LinkWithIcon";
import { useState, useCallback } from "react";
import NewRingDrawer from "../../drawers/NewRingDrawer";

const useStyles = makeStyles({
    toolbar: {
        backgroundColor: tokens.colorNeutralBackground2,
        borderRadius: tokens.borderRadiusMedium,
        padding: "0.25rem"
    }
});

const AddIcon = bundleIcon( AddFilled, AddRegular );

export default function FlightOps_Rings() {
    const styles = useStyles();
    const [ newRingOpen, setNewRingOpen ] = useState( false );

    const createRingCallback = useCallback(
        ( name: string ) => {
            // TODO
        },
        []
    );
    
    return (
        <>
            <Toolbar className={styles.toolbar}>
                <Button appearance="subtle" icon={<AddIcon />} onClick={() => setNewRingOpen( true )}>
                    New Ring
                </Button>
            </Toolbar>

            <Table style={{ marginTop: "1rem" }}>
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell>Ring</TableHeaderCell>
                        <TableHeaderCell align="right">Active builds</TableHeaderCell>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    <TableRow>
                        <TableCell><LinkWithIcon href="/flightops/rings/Canary" text="Canary" /></TableCell>
                        <TableCell align="right">1</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell><LinkWithIcon href="/flightops/rings/Beta" text="Beta" /></TableCell>
                        <TableCell align="right">1</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell><LinkWithIcon href="/flightops/rings/Release" text="Release" /> <Tooltip relationship="label" content={"Default Ring"}><CheckmarkCircleRegular /></Tooltip></TableCell>
                        <TableCell align="right">2</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            
            <NewRingDrawer open={newRingOpen} setOpen={setNewRingOpen} createRingCallback={createRingCallback} />
        </>
    );
}